import { APP_CODE_NAME } from '../../constants';
export const COMPONENT_NAME = 'Player';

export const SHOW_ID = `${APP_CODE_NAME}__${COMPONENT_NAME}__SHOW_ID`;
export const SHOW_API_REQUEST_INIT = `${APP_CODE_NAME}__${COMPONENT_NAME}__SHOW_API_REQUEST_INIT`;
export const SHOW_API_REQUEST_SUCCESS = `${APP_CODE_NAME}__${COMPONENT_NAME}__SHOW_API_REQUEST_SUCCESS`;
export const SHOW_API_REQUEST_FAILURE = `${APP_CODE_NAME}__${COMPONENT_NAME}__SHOW_API_REQUEST_FAILURE`;

export const TRACK_API_REQUEST_INIT = `${APP_CODE_NAME}__${COMPONENT_NAME}__TRACK_API_REQUEST_INIT`;
export const TRACK_API_REQUEST_SUCCESS = `${APP_CODE_NAME}__${COMPONENT_NAME}__TRACK_API_REQUEST_SUCCESS`;
export const TRACK_API_REQUEST_FAILURE = `${APP_CODE_NAME}__${COMPONENT_NAME}__TRACK_API_REQUEST_FAILURE`;

export const TOGGLE_PLAY_STATUS = `${APP_CODE_NAME}__${COMPONENT_NAME}__TOGGLE_PLAY_STATUS`;
export const SET_PLAY_STATUS = `${APP_CODE_NAME}__${COMPONENT_NAME}__SET_PLAY_STATUS`;
export const SET_CURRENTLY_PLAYING_TRACK_ID = `${APP_CODE_NAME}__${COMPONENT_NAME}__SET_CURRENTLY_PLAYING_TRACK_ID`;
export const SEEK = `${APP_CODE_NAME}__${COMPONENT_NAME}__SEEK`;
export const SEEKING = `${APP_CODE_NAME}__${COMPONENT_NAME}__SEEKING`;
export const TRACK_PROGRESS = `${APP_CODE_NAME}__${COMPONENT_NAME}__TRACK_PROGRESS`;
export const TRACK_END = `${APP_CODE_NAME}__${COMPONENT_NAME}__TRACK_END`;
export const TRACK_DURATION = `${APP_CODE_NAME}__${COMPONENT_NAME}__TRACK_DURATION`;

export const SEND_LOG_EVENT = `${APP_CODE_NAME}__${COMPONENT_NAME}__SEND_LOG_EVENT`;

export const PLAYING = 'PLAYING';
export const PAUSED = 'PAUSED';
export const STOPED = 'STOPED';

// These exact strings are expected by API
export const LOG_EVENT_FINISHED = 'finished';
export const LOG_EVENT_SKIP = 'skip';
export const LOG_EVENT_PAUSE = 'pause';
export const LOG_EVENT_PLAY_FROM_PAUSE = 'play_from_pause';
export const LOG_EVENT_SEEK = 'seek';
